<template>
  <div>
    <!-- {{ lensIDs }} -->
    <div class="d-none d-print-block">
      <div
        v-for="eye in ['od', 'os']"
        :key="eye"
        class="d-flex flex-row align-center mr-2"
      >
        <div class="font-weight-bold">Brand ({{ eye | eyeLetter }})</div>
        <div v-if="brand[eye] && brand[eye].name">
          &nbsp;&nbsp;
          {{ brand[eye].name }}
        </div>
        <div v-if="replacementText[eye]" class="caption">
          &nbsp;&nbsp;({{ replacementText[eye] }})
        </div>
      </div>
    </div>
    <div class="d-flex flex-column flex-md-row bkg justify-center ma-2">
      <div
        class="d-flex flex-column flex-sm-row flex-md-column d-print-none mb-2 justify-center justify-md-start"
      >
        <eye-lens-panel
          v-for="(eye, index) in ['od', 'os']"
          :key="index"
          class="mx-0 mr-sm-1 mr-md-3 mb-3"
          :class="eyePanelWidth"
          :eye="eye"
          :initialLensId="initialLensIdForEye[eye]"
          :priceData="priceData"
          :brand="brand[eye]"
          @brandChange="brandChange(eye, $event)"
          @priceDataChange="priceDataChange(eye, $event)"
        ></eye-lens-panel>
      </div>

      <div
        class="d-flex flex-column flex-sm-row d-print-table-row justify-center justify-md-start"
      >
        <supply-calculator
          :feesDiscounts="feesDiscounts"
          :priceData="priceData"
          :isYear="true"
          :savings="savings"
          :showOtherSupply="showOtherSupply"
          @costToPatient="yearCost = $event"
          @switchShowOtherSupply="switchShowOtherSupply()"
          class="mr-0 mr-sm-1 mr-md-3 mb-3 d-print-table-cell mr-print-2"
          :class="calculatorWidth"
        ></supply-calculator>

        <!-- <v-fade-transition> -->
        <supply-calculator
          :feesDiscounts="feesDiscounts"
          :priceData="priceData"
          @costToPatient="partialCost = $event"
          class="mx-0 mr-sm-1 mr-md-4 mb-3 d-print-table-cell"
          v-if="showOtherSupply"
          :class="[calculatorWidth, showOnPrint]"
        ></supply-calculator>
        <!-- <div v-else small depressed color="primary" class="ma-6 text-center">
          <v-btn
            outlined
            rounded
            small
            color="primary"
            @click="showOtherSupply = true"
            class="d-print-none"
            >Calculate other supply</v-btn
          >
          <div class="caption">(3 month, 6 month, etc.)</div>
        </div> -->
        <!-- </v-fade-transition> -->
      </div>
    </div>
    <!-- <set-brand-price></set-brand-price> -->
  </div>
</template>

<script>
// import Name from "../dir/file";
import EyeLensPanel from "./EyeLensPanel.vue";
import SupplyCalculator from "./SupplyCalculator.vue";
import FilterDictionary from "@/assets/js/cls/FilterDictionary";

// import SetBrandPrice from "./SetBrandPrice";
// import { replacementTextForDays } from "./utilities/lensHelpers";
// import FilterDictionary from "@/assets/js/cls/FilterDictionary";

export default {
  name: "PriceCalcTab",
  components: {
    EyeLensPanel,
    SupplyCalculator,
    // SetBrandPrice,
  },
  props: {
    lensIDs: null, // lens ids IF the lens ID was initially set in the URL query string
    index: null,
    feesDiscounts: {
      type: Object,
      default: function () {
        return {
          insurance: 0,
          yearDiscount: 0,
          shippingYear: 0,
          shippingPartial: 0,
          willShip: true,
        };
      },
    },
  },
  data: function () {
    return {
      brand: { od: null, os: null },
      priceData: { od: null, os: null },
      isLoading: { od: false, os: false },
      suggestionDialog: false,
      yearCost: null,
      partialCost: null,
      showOtherSupply: true,
      // imagePath: "https://www.eyedock.com/modules/Lenses/pnimages/lens_images/",
    };
  },
  methods: {
    // replacementTextForDays,
    // fillPackageOption(eye, pkgObj) {
    //   this.qty[eye] = pkgObj.qty;
    //   this.amt[eye] = pkgObj.amt;
    // },
    otherEye(eye) {
      return eye == "od" ? "os" : "od";
    },
    brandChange(eye, data) {
      this.brand[eye] = data;
      // figure out the title for the tab
      let name = this.brand?.od?.name || this.brand?.os?.name;
      if (this.brand?.od?.familyName) name = this.brand.od.familyName;
      let image = this.brand?.od?.image || this.brand?.os?.image;
      if (name) this.$emit("brandData", { title: name, image: image });

      // if the other eye's brand isn't set, assume this will be the same brand
      let otherEye = this.otherEye(eye);
      if (!this.brand[otherEye]) {
        // console.log("copying brand");
        this.brandChange(otherEye, data);
        // this.priceDataChange(otherEye, this.priceData[eye]);
      }
    },
    priceDataChange(eye, data) {
      // console.log("priceDataChange", eye, data);
      this.priceData[eye] = data;

      // if we're updating the lens price data, and the fellow eye is the same lens, update the price data for that eye's lens too.
      let otherEye = this.otherEye(eye);
      let id_eye = this.brandIdForEye[eye];
      let id_other = this.brandIdForEye[otherEye];
      if (id_other && id_eye == id_other) this.priceData[otherEye] = data;

      this.suggestionDialog = this.priceData.od && !this.brand.os;
    },
    switchShowOtherSupply() {
      this.showOtherSupply = !this.showOtherSupply;
    },
    // resetClicked() {
    //   console.log("resetClicked");
    // },
  },

  computed: {
    // this will be the year supply cost less the partial supply cost (extrapolated to 1 year)
    savings: function () {
      if (!this.yearCost || !this.partialCost) return null;
      let savings = parseFloat(this.partialCost) - parseFloat(this.yearCost);
      return savings > 0 ? savings : null;
    },
    replacementText: function () {
      let rtn = { od: null, os: null };
      if (this.brand?.od?.groups?.replace)
        // rtn.od = this.replacementTextForDays(this.brand.od.groups.replace);
        rtn.od = FilterDictionary.replaceTitleForDays(
          this.brand.od.groups.replace
        );
      if (this.brand?.os?.groups?.replace)
        // rtn.os = this.replacementTextForDays(this.brand.os.groups.replace);
        rtn.os = FilterDictionary.replaceTitleForDays(
          this.brand.os.groups.replace
        );
      return rtn;
    },
    eyePanelWidth: function () {
      let aClass = "eyePanel";
      if (this.$vuetify.breakpoint.smAndUp) aClass = "eyePanelSm";
      if (this.$vuetify.breakpoint.mdAndUp) aClass = "eyePanelMd";
      return aClass;
    },
    calculatorWidth: function () {
      let aClass = "calculator";
      if (this.$vuetify.breakpoint.smAndUp) aClass = "calculatorSm";
      if (this.$vuetify.breakpoint.mdAndUp) aClass = "calculatorMd";
      return aClass;
    },

    showOnPrint: function () {
      return this.partialCost ? "d-print-table-cell" : "d-print-none";
    },
    // the current lens Ids
    brandIdForEye: function () {
      let rtn = {};
      rtn.od = this.brand?.od?.id ? parseInt(this.brand.od.id) : null;
      rtn.os = this.brand?.os?.id ? parseInt(this.brand.os.id) : null;
      return rtn;
    },
    // lens ids IF the lens ID was initially set in the URL query string
    initialLensIdForEye: function () {
      let rtn = { od: null, os: null };
      if (!this.lensIDs || this.index != 0) return rtn;
      let ids = this.lensIDs;
      if (!Array.isArray(this.lensIDs)) {
        rtn = { od: ids, os: ids };
      } else {
        if (ids.length == 1) ids[1] = ids[0];
        rtn = { od: ids[0], os: ids[1] };
      }
      return rtn;
    },
  },
};
</script>

<style scoped>
.bkg {
  background-color: transparent;
}
.eyePanel {
  width: 100%;
}
.eyePanelSm {
  width: 47%;
  min-height: 200px;
}
.eyePanelMd {
  width: 290px;
  min-height: 250px;
}
.calculator {
  width: 100%;
}
.calculatorSm {
  width: 47%;
}
.calculatorMd {
  width: 500px;
}
@media print {
  .eyePanel {
    width: 47%;
  }
  .eyePanelSm {
    width: 47%;
  }
  .eyePanelMd {
    width: 47%;
  }
  .calculator {
    width: 47%;
  }
  .calculatorSm {
    width: 47%;
  }
  .calculatorMd {
    width: 47%;
  }
}
</style>
